import ReactPixel from 'react-facebook-pixel';

export const addFacebookSearchEvent = (query) => {
  ReactPixel.track('Search', {
    content_name: query,
  });
};
